import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Header from './components/Header';
import Hero from './components/Hero';
import Menu from './components/Menu';
import MenuList from './components/MenuList';
import Modal from './components/Modal';
import Service from './components/Service';
import Statistics from './components/Statistics';
import Reviews from './components/Reviews';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import { useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

function App() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <Router>
      <div className="App">
        <Switch>
          <Route exact path="/">
            <Header />
            <Hero />
            <About />
            <Service />
            <Menu setSelectedImg={setSelectedImg} />
            <Statistics />
            <Reviews />
            <Contact />
          </Route>
        </Switch>
        <Switch>
          <Route exact path="/menu">
            <MenuList setSelectedImg={setSelectedImg} />
          </Route>
        </Switch>
        {selectedImg && (
          <Modal selectedImg={selectedImg} setSelectedImg={setSelectedImg} />
        )}
        <Footer />
        <MessengerCustomerChat
          pageId="111743847358354"
          appId="1894071630750082"
        />
      </div>
    </Router>
  );
}

export default App;
